<!-- Modal-Help -->
<div class="modal fade" id="help-Modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content dirI">
            <div class="modal-header">
                <h5 class="modal-title bold txt-navy">راهنمای {{ webAppName }} </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body overflow-auto" style="max-height: 50vh;">
                <div class="d-flex flex-column justify-content-center">
                    <a class="text-start my-1 text-dark pointer" *ngFor="let item of helpData;let i=index"
                        href="{{item.strURL}}" target="_blank">
                        {{i+1}}-
                        <img src="../../../assets/Img/free-movie-icon-850-thumb.png" width="40px" height="40px"
                            *ngIf="item.tiType==1">
                        <img src="../../../assets/Img/PDF_file_icon.svg.png" width="40px" height="50px"
                            *ngIf="item.tiType==2">
                        {{item.strTitle}}
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>
